import { default as posthog } from 'posthog-js';
import { useEffect } from 'react';

import { env } from '~/environment/env';

export function PosthogClient() {
  useEffect(() => {
    const apiToken = env.PUBLIC_POSTHOG_API_TOKEN;
    const apiHost = env.PUBLIC_POSTHOG_API_HOST;

    posthog.init(apiToken, {
      api_host: apiHost,
    });
  }, []);

  return null;
}
